import * as React from 'react'

import { Text, TextName } from 'sdk'

import classes from './style.module.scss'

export interface Feature {
  icon: string
  title: string
  description?: string
}

interface FeaturesGridProps {
  features: Feature[]
  className?: string
}

export const FeaturesGrid: React.FC<FeaturesGridProps> = ({ features, className }) => {
  return (
    <div className={`${classes.featuresGrid} ${className || ''}`}>
      {features.map((feature, index) => (
        <div key={index} className={classes.featureItem}>
          <img src={feature.icon} alt='' width={25} height={25} />

          <div className={classes.featureText}>
            <Text type={TextName.TextBold} className={classes.title}>{feature.title}</Text>
            {feature.description && (
              <Text type={TextName.Text} className={classes.description}>
                {feature.description}
              </Text>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
